import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import React, { PureComponent } from 'react';
/**
 * @deprecated Use `<WithOutsideClick>` from `@scp/ui-shared/components/wrappers`.
 */

export function withOutsideClick(Component) {
  return /*#__PURE__*/function (_PureComponent) {
    _inherits(_class, _PureComponent);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.apply(this, arguments);
      _this.isClickedInside = false;

      _this.handleDocumentClick = function () {
        if (_this.isClickedInside) {
          _this.isClickedInside = false;
          return;
        }

        var onClickOutside = _this.props.onClickOutside;
        if (!onClickOutside) return;
        onClickOutside();
      };

      _this.handleClick = function () {
        _this.isClickedInside = true;
      };

      return _this;
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
      }
    }, {
      key: "render",
      value: function render() {
        var _a = this.props,
            onClickOutside = _a.onClickOutside,
            props = __rest(_a, ["onClickOutside"]);

        return React.createElement(Component, Object.assign({}, props, {
          onClickCapture: this.handleClick
        }));
      }
    }]);

    return _class;
  }(PureComponent);
}